import React, { useEffect, useState } from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import swal from 'sweetalert';
import { Button } from "react-bootstrap";
import { getAllItemsData } from "../../Utility/Api";
import { endPoints, Image_Url } from "../../Constant/Environment";
import { getFullUrl } from "../../Constant/makeApiCall";
import MetaTags from '../MetaTags';
import { Actions } from "../../redux/Actions/Actions";
import Loader from '../Loader';
import { InfinitySpin } from 'react-loader-spinner'
import { useModal } from '../../ModalContext';

function Traveler() {
  const { handleFirstModalOpen} = useModal();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { isAuthenticated, traveler, user } = useSelector((state) => state.auth);
  // const { travelerPageData, getBenefit } = useSelector((state) => state.travelerPageData); 
  const [travelerPageData, setTravelerPageData] = useState({});
  const [getBenefit, setGetBenefit] = useState([]);
  const checkLogin = () => {
    swal('Error!', "Please Login as Traveler", 'error');
  };

  const getTravelerPageData = () => {
    let url = `${endPoints.api.TRAVELER_PAGE_DATA}`;
    setIsLoading(true);

    getAllItemsData(url)
      .then((response) => {
        const { status, data } = response;
        if (status === 200) {
          const { travelerPage, benefit } = data;
          setTravelerPageData(travelerPage);
          setGetBenefit(benefit);
          setIsLoading(false);
          // dispatch({
          //   type: Actions.FETCH_TRAVELER_PAGE_DATA_SUCCESS,
          //   data: {
          //     travelerPageData: travelerPage,
          //     getBenefit: benefit
          //   },
          // }); 

        } else {
          // Handle error or show a message
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };


  useEffect(() => {
    // if (travelerPageData.length == 0) {
    // }
    getTravelerPageData();
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <>
      {isLoading ? (
        // <Loader spinner={true} visible={isLoading} className="loader" />
        <div className="page_loader"><InfinitySpin
          visible={true}
          width="200"
          color="#4fa94d"
          ariaLabel="infinity-spin-loading"
        /></div>
      ) : (
        <>
          <MetaTags
            title={travelerPageData && travelerPageData.meta_title}
            description={travelerPageData && travelerPageData.meta_descriptions}
            image={Image_Url + travelerPageData.banner}
            canonicalUrl={getFullUrl()}
          />
          <div className="banner-inner">
            {travelerPageData && travelerPageData.banner ? (
              <img
                src={Image_Url + travelerPageData.banner}
                alt="logo1"
              // loading="lazy"
              />
            ) : null}
            <div className="banner-text">
              <h3 className="c-heading">{travelerPageData && travelerPageData.banner_title}</h3>
              <p>{travelerPageData && travelerPageData.banner_descriptions}</p>
            </div>
          </div>

          <main className="middle contact-page">
            <section className="pt-3">
              <div className="container">
                <Breadcrumb>
                  <Breadcrumb.Item>Welcome</Breadcrumb.Item>
                  <Breadcrumb.Item active>For Travelers</Breadcrumb.Item>
                </Breadcrumb>
                <h2 className="c-heading text-center sec-padd-t">
                  I am a <span className="send-span">TRAVELER</span>
                </h2>
                <p className="gray-color text-center">
                  Simply follow these four easy steps
                </p>
                <div className="row gy-4 gx-0 pt-5 sec-padd sender-set">
                  <div className="col-md-6">
                    <div className="sender-box">
                      <div className="d-flex">
                        <div className="sender-box1">
                          <h5>1</h5>
                        </div>
                        <div className="sender-text">
                          <h4>{travelerPageData && travelerPageData.first_title}</h4>
                        </div>
                      </div>
                      <p>
                        {travelerPageData && travelerPageData.first_descriptions}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {travelerPageData && travelerPageData.first_image ? (

                      <img
                        src={Image_Url + travelerPageData.first_image}
                        alt="logo1"
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    {travelerPageData && travelerPageData.second_image ? (

                      <img
                        src={Image_Url + travelerPageData.second_image}
                        alt="logo1"
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <div className="sender-box">
                      <div className="d-flex">
                        <div className="sender-box1">
                          <h5>2</h5>
                        </div>
                        <div className="sender-text">
                          <h4>{travelerPageData && travelerPageData.second_title}</h4>
                        </div>
                      </div>
                      <p>
                        {travelerPageData && travelerPageData.second_descriptions}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="sender-box">
                      <div className="d-flex">
                        <div className="sender-box1">
                          <h5>3</h5>
                        </div>
                        <div className="sender-text">
                          <h4>{travelerPageData && travelerPageData.third_title}</h4>
                        </div>
                      </div>
                      <p>
                        {travelerPageData && travelerPageData.third_descriptions}
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {travelerPageData && travelerPageData.third_image ? (

                      <img
                        src={Image_Url + travelerPageData.third_image}
                        alt="logo1"
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    {travelerPageData && travelerPageData.fourth_image ? (

                      <img
                        src={Image_Url + travelerPageData.fourth_image}
                        alt="logo1"
                      />
                    ) : null}
                  </div>
                  <div className="col-md-6">
                    <div className="sender-box">
                      <div className="d-flex">
                        <div className="sender-box1">
                          <h5>4</h5>
                        </div>
                        <div className="sender-text">
                          <h4>{travelerPageData && travelerPageData.fourth_title}</h4>
                        </div>
                      </div>
                      <p>
                        {travelerPageData && travelerPageData.fourth_descriptions}
                      </p>
                    </div>
                  </div>
                  <div class=" d-flex align-items-center justify-content-center mt-5 senderBtn">
                    {isAuthenticated && Object.entries(user).length !== 0 && (user.payment_status === 'Pending' || user.payment_status === 'Cancel') ? <>
                      <Link to="/dashboard" class="sender-btn">
                        Register As Traveler
                      </Link>
                    </> : <>
                      <Button onClick={handleFirstModalOpen} class="sender-btn">
                        Register As Traveler
                      </Button>
                    </>}
                  </div>
                </div>
              </div>
            </section>
            <section className="sec-padd middle bg-white sender">
              <Container>
                <h3 className="c-heading text-center mb-5">
                  Benefits For Travelers
                </h3>
                <Row className="g-5">
                  {getBenefit.map((data, index) => (
                    <Col md={4}>
                      <div className="work-box">
                        <img
                          src={Image_Url + data.image}
                          alt="logo2"
                        />
                        <h4>{data.title}</h4>
                        <p>
                          {data.descriptions}
                        </p>
                      </div>
                    </Col>
                  ))}

                </Row>
              </Container>
            </section>
          </main>
        </>
      )}
    </>
  );
}

export default Traveler;
